import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useOffer from "../../../api/hooks/useOffers";
import useZip from "../../../api/hooks/useZip";
import { getOptions } from "../../../api/utils";
import Footer from "../../../components/Footer";
import CustomInput from "../../../components/inputs/CustomInput";
import LogMessage from "../../../components/misc/LogMessage";
import ModelCard from "../../../components/models/ModelCard";
import OfferCreateSpecs from "../../../components/offer/OfferCreateSpecs";
import { logMsgBgColors } from "../../../consts/misc";
import { toAssets, toIcons } from "../../../consts/Paths";
import useIsMobile from "../../../hooks/useIsMobile";
import useLogMessage from "../../../hooks/useLogMessage";
import useToggle from "../../../hooks/useToggle";
import {
  Offer,
  OfferShareResponse,
  Shared_model_info,
} from "../../../interfaces";
import { modelsRemappingFromSharedResponse } from "../../../utils/modelRemapping";
import { formatDateGGMMYYYY } from "../../../utils/reformatDate";

const ShareOfferPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const passwordForm = useForm();
  const logMessage = useLogMessage();
  const url = new URL(window.location.href);
  const zipHook = useZip();
  const offerHook = useOffer();
  const [dataFetched, setDataFetched] = useState<OfferShareResponse | null>(
    null
  );
  const [offer, setOffer] = useState<Offer | null>(null);
  const [proposedModelList, setProposedModelList] = useState<any[] | null>(
    null
  );
  const [userSharing, setUserSharing] = useState({
    name: "",
    surname: "",
  });
  const [isPasswordNeeded, setIsPasswordNeeded] = useState(false);

  const [isDownloadAllCompositeVisible, setIsDownloadAllCompositeVisible] =
    useState(false);
  const [isDownloadAllLookbookVisible, setIsDownloadAllLookbookVisible] =
    useState(false);

  const tempLoading = useToggle(false);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  useEffect(() => {
    callGetSharedApi();
  }, []);

  useEffect(() => {
    if (dataFetched) {
      /* console.log(dataFetched); */
      setOffer(dataFetched.offert);
      setUserSharing(dataFetched.user_sharing);
      if (dataFetched.related_models) {
        const remappedModelsList = modelsRemappingFromSharedResponse(
          dataFetched.related_models
        );
        setProposedModelList(remappedModelsList);
        const someLookbook = remappedModelsList.some(
          (model) => model.lookbook != null
        );
        setIsDownloadAllLookbookVisible(someLookbook);
        const someComposite = remappedModelsList.some(
          (model) => model.composite != null
        );
        setIsDownloadAllCompositeVisible(someComposite);
      }
    }
  }, [dataFetched]);

  const callGetSharedApi = (password?: string) => {
    const tToken = url.searchParams.get("token");
    /* const s = url.pathname;
    const id = Number.parseInt(s.slice(s.lastIndexOf(`/`) + 1, s.length)); */
    if (tToken) {
      let finalObject: any = {
        token: tToken,
      };
      if (password) {
        finalObject["password"] = password;
        offerHook.CTAs.getSharedOffer(finalObject);
      } else if (!password) {
        offerHook.CTAs.getSharedOffer(finalObject);
      }
    }
  };

  const onPasswordSubmit = (data: any) => {
    callGetSharedApi(data.password);
  };

  useEffect(() => {
    /* console.log(
      offerHook.RESPONSES.getSharedOfferResponse,
      offerHook.RESULTS.getSharedOfferResult
    ); */
    if (offerHook.RESPONSES.getSharedOfferResponse?.ok) {
      setIsPasswordNeeded(false);
      setDataFetched(offerHook.RESULTS.getSharedOfferResult.data);
    } else if (
      offerHook.RESPONSES.getSharedOfferResponse?.ok === false &&
      offerHook.RESPONSES.getSharedOfferResponse?.status === 401
    ) {
      setIsPasswordNeeded(true);
    }
    if (offerHook.RESULTS.getSharedOfferResult?.message === "Wrong Password") {
      tempLoading.setIsToggled(false);
      logMessage.write(
        "subject",
        `${offerHook.RESULTS.getSharedOfferResult?.message}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [offerHook.RESPONSES.getSharedOfferResponse]);

  const downloadAll = async (choice: string) => {
    const tToken = url.searchParams.get("token");
    if (tToken) {
      zipHook.CTAs.getSharedZip(tToken, choice);
    }
  };

  useEffect(() => {
    /* console.log(zipHook.RESPONSES.getSharedZipResponse); */
    if (zipHook.RESPONSES.getSharedZipResponse?.ok) {
      const url = zipHook.RESPONSES.getSharedZipResponse.url; 
      const link = document.createElement("a");
      link.href = url;  
      link.click();
      /* window.open(url, "_blank"); */
    }
  }, [zipHook.RESPONSES.getSharedZipResponse]);

  const renderModelCards = proposedModelList?.map((model, key) => {
    return (
      <ModelCard
        key={key}
        model={model}
        readOnly={props.readOnly}
        logMessage={props.logMessage}
        shareLayout={true}
      />
    );
  });

  return (
    <div className="access-background" style={{ overflow: "hidden" }}>
      <img
        style={{ marginTop: "45px", marginBottom: "60px" }}
        className="Logo_2-POS4x"
        src={`${toAssets}/Logo_2-POS@4x.png`}
      />
      {logMessage.isToggled && (
        <LogMessage
          text={{
            subject: logMessage.message.subject,
            other_text: logMessage.message.other_text,
            complement: logMessage.message.complement,
          }}
          bgColor={logMessage.message.bgColor}
        />
      )}
      {/*  */}
      {offer ? (
        <>
          <div className="offer-shared-advertise-box">
            {/*User and offer info to set when know response from service */}
            <span className="offer-shared-advertise-text-box">
              <p className="offer-shared-advertise-text">
                <strong className="black">
                  {userSharing.name ? userSharing.name : ""}{" "}
                  {userSharing.surname ? userSharing.surname : ""}
                </strong>{" "}
                has shared this offer with you
              </p>
            </span>
          </div>
          <div
            className="offer-shared-advertise-date-box"
            style={{
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "0" : "",
              marginTop: isMobile ? "15px" : "",
            }}
          >
            {dataFetched?.shared_on && (
              <>
                <p className="offer-shared-advertise-text">shared on:</p>
                <p className="offer-shared-advertise-date">
                  {formatDateGGMMYYYY(new Date(dataFetched?.shared_on))}
                </p>
              </>
            )}
            {dataFetched?.expiration_date && (
              <>
                {isMobile ? "" : "-"}
                <p className="offer-shared-advertise-text">expire on:</p>
                <p className="offer-shared-advertise-date">
                  {formatDateGGMMYYYY(new Date(dataFetched?.expiration_date))}
                </p>
              </>
            )}
          </div>
          <div>
            <OfferCreateSpecs
              width={isMobile ? 345 : 870}
              offer={offer}
              shared={true}
            />
          </div>

          <div
            className="offer-shared-models-recap shadow"
            style={{
              width: isMobile ? "346.6px" : "",
              marginTop: isMobile ? "20px" : "",
            }}
          >
            <div
              className="offer-shared-models-recap-header"
              style={{
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <div className="offer-shared-models-recap-info-box">
                <p className="offer-shared-models-recap-info-title">
                  Suggested Models {proposedModelList?.length} for{" "}
                  {offer.requested_models}
                </p>
                <p className="offer-shared-models-recap-info-description">
                  Our selection
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "15px",
                  marginLeft: isMobile ? "-50px" : "",
                }}
              >
                {
                  /* !isMobile && */ isDownloadAllCompositeVisible && (
                    <div
                      className="offer-shared-models-recap-cta-box offLightBlue"
                      onClick={() => downloadAll("composite")}
                    >
                      <img
                        className="offer-shared-models-recap-cta-icon"
                        src={`${toIcons}/composite.svg`}
                        alt=""
                      />
                      <p className="offer-shared-models-recap-cta-icon-text">
                        {!isMobile && "Download"} {isMobile ? "" : "all "}
                        composites
                      </p>
                    </div>
                  )
                }
                {
                  /* !isMobile && */ isDownloadAllLookbookVisible && (
                    <div
                      className="offer-shared-models-recap-cta-box offLightBlue"
                      onClick={() => downloadAll("lookbook")}
                    >
                      <img
                        className="offer-shared-models-recap-cta-icon"
                        src={`${toIcons}/lookbook.svg`}
                        alt=""
                      />
                      <p className="offer-shared-models-recap-cta-icon-text">
                        {!isMobile && "Download"} {isMobile ? "" : "all "}
                        books
                      </p>
                    </div>
                  )
                }
              </div>
            </div>
            <div
              className="offer-shared-models-recap-content"
              style={{
                width: isMobile ? "305px" : "",
                minHeight: isMobile ? "56px" : "",
                maxHeight: isMobile ? "fit-content" : "",
                padding: isMobile ? "" : "",
                gridTemplateColumns: isMobile ? "1fr" : "",
                display: isMobile ? "flex" : "grid",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              {renderModelCards}
            </div>
          </div>
          {offer.long_description && (
            <div
              className="offer-shared-description-box shadow"
              style={{
                width: isMobile ? "344.9px" : "",
                height: isMobile ? "305.6px" : "",
                marginTop: isMobile ? "20px" : "",
              }}
            >
              <p
                className="offer-shared-description-title"
                style={{ margin: isMobile ? "24px 156px 16px 24px" : "" }}
              >
                Offer description
              </p>
              <div
                className="offer-shared-description-wrapper"
                style={{
                  width: isMobile ? "75%" : "",
                  height: isMobile ? "70%" : "",
                  margin: isMobile ? "19px auto" : "",
                }}
              >
                <p className="offer-shared-description">
                  {offer.long_description}
                </p>
              </div>
            </div>
          )}
          {offer.budget && (
            <div
              className="offer-shared-budget-box shadow"
              style={{
                width: isMobile ? "345px" : "",
                flexDirection: isMobile ? "column" : "row",
                height: isMobile ? "146.2px" : "",
                justifyContent: isMobile ? "flex-start" : "space-between",
                marginTop: isMobile ? "20px" : "",
                padding: isMobile ? "" : "25px 0",
              }}
            >
              <p
                className="offer-shared-budget-title"
                style={{ margin: isMobile ? "24px auto 16px 24px" : "" }}
              >
                Budget
              </p>
              <div
                className="offer-shared-budget-wrapper"
                style={{
                  width: isMobile ? "305px" : "",
                  margin: isMobile ? "0" : "",
                }}
              >
                <img
                  className="offer-shared-budget-icon"
                  src={`${toIcons}/wallet.svg`}
                  alt=""
                />
                <p className="offer-shared-budget-value">€{offer.budget}</p>
              </div>
            </div>
          )}
        </>
      ) : isPasswordNeeded ? (
        <div
          className={`access-content-box ${isMobile && "a-c-b-Mob"}`}
          style={{ marginTop: isMobile ? "" : "49px" }}
        >
          <div className="access-content-box-inner-wrapper">
            <form onSubmit={passwordForm.handleSubmit(onPasswordSubmit)}>
              <div className="access-contentBox-header">
                <div className="cornerTitle">
                  {"Private Offer"}
                  <p className="cornerSubTitle">
                    {"Insert the correct password to see this offer"}
                  </p>
                </div>
              </div>
              <div style={{ marginTop: "32px" }}>
                <div style={{ marginTop: "-20px" }}>
                  <CustomInput
                    width={isMobile ? 305 : 460}
                    name="password"
                    type="password"
                    register={passwordForm.register}
                    errors={passwordForm.formState.errors}
                  />
                </div>
              </div>
              <div
                className="contentBox-confirmationBox"
                style={{ justifyContent: "right", marginTop: "50px" }}
              >
                <button className="button1 b-short" type="submit">
                  <p className="button1-text">{"Confirm"}</p>
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          marginTop: isMobile ? "101.8px" : "82px",
          marginBottom: isMobile ? "31px" : "60px",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
export default ShareOfferPage;
